<template>
    <TprmModal
        additional-class-name="AMBestRatingDisclaimerProcedure"
        open
        allow-close
        size="lg"
        title="AM Best Rating Disclaimer"
        @close="close"
    >
        <p>
            "Best's Credit Ratings™ are under continuous review and subject to change and/or affirmation. For the latest
            Best's Credit Ratings™ and Best's Credit Reports (which include Best's Credit Ratings™), visit the A.M. Best
            website at <a class="AMBestRatingDisclaimerProcedure__link" target="_blank" href="http://www.ambest.com">http://www.ambest.com</a>. See Guide to Best's
            Credit Ratings™ for explanation of use and charges."
        </p>
        <p>
            "Best's Credit Ratings™ reproduced herein appear under license from A.M. Best and do not constitute, either
            expressly or impliedly, an endorsement of Evident or its recommendations, formulas, criteria or comparisons
            to any other ratings, rating scales or rating organizations which are published or referenced herein. A.M.
            Best is not responsible for transcription errors made in presenting Best's Credit Ratings™.
        </p>
        <p>
            Best's Credit Ratings™ are proprietary and may not be reproduced or distributed without the express written
            permission of A.M. Best Company."
            A Best's Financial Strength Rating opinion addresses the relative ability of an insurer to meet its ongoing
            insurance obligations. It is not a warranty of a company's financial strength and ability to meet its
            obligations to policyholders. View our Important Notice: Best's Credit Ratings for a disclaimer notice and
            complete details at <a class="AMBestRatingDisclaimerProcedure__link" target="_blank" href="http://www.ambest.com/ratings/index.html">http://www.ambest.com/ratings/index.html</a>.
        </p>
    </TprmModal>
</template>

<style lang="scss">
    .AMBestRatingDisclaimerProcedure {
        &__link {
            color: var(--eidSecureBlue);
        }

        .Modal__body {
            max-width: 700px;
        }
    }
</style>

<script lang="ts">
    import { defineComponent } from 'vue';

    import TprmModal from '@/components/tprm-modal/TprmModal.vue';

    // PRODUCT-26110 QA fixes4: declares the `abort` event this procedure component
    // `$emit`s -- without a declared `emits`, Vue 3 warns "Component emitted event
    // 'abort' but it is neither declared in the emits option nor as an 'onAbort' prop"
    // every time it fires.
    export default defineComponent({
        name: 'AMBestRatingDisclaimerProcedure',
        components: { TprmModal },
        // PRODUCT-26110 QA fixes4: ProcedureTarget.vue passes `:uuid="execution.uuid"` to
        // every dynamically-rendered procedure component; no procedure consumes the
        // value, it's declared here purely so Vue 3 doesn't warn "Extraneous non-props
        // attributes (uuid)" (see UploadEntityDocumentProcedure.vue for the full note).
        props: {
            uuid: {
                type: String,
                default: '',
            },
        },
        emits: [ 'abort' ],
        methods: {
            close(): void {
                this.$emit('abort');
            },
        },
    });
</script>
